import { Observable } from 'rxjs';
import { apiClient } from '~admin/client';
import { AdminLoginRequest } from '~client/model/admin/admin-login-request';
import { AdminLoginResponse } from '~client/model/admin/admin-login-response';
import { OneArgTask, rxTask } from '~common/helper/mobx-tasks';

//TODO(Asif): Create internal models & mappers
export type LoginTask = OneArgTask<AdminLoginRequest, AdminLoginResponse>;

const performLogin = (request: AdminLoginRequest): Observable<AdminLoginResponse> =>
  apiClient.adminController.login$(request);

export const loginTaskFactory = (): LoginTask =>
  rxTask((request: AdminLoginRequest) => performLogin(request));



// WEBPACK FOOTER //
// ./interactor/login/perform-login.ts